import { render, staticRenderFns } from "./ClassifyIface.vue?vue&type=template&id=0d416728&scoped=true&"
import script from "./ClassifyIface.vue?vue&type=script&lang=js&"
export * from "./ClassifyIface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d416728",
  null
  
)

export default component.exports